<template>
    <rise-loader :loading="loaderStatus" :color="color" :size="size" ></rise-loader>
</template>

<script>
    import riseLoader from 'vue-spinner/src/RiseLoader'
    export default {
        name: "Loader",
        data(){
            return{
                color: '#5e72e4',
                size: '8px'
            }
        },
        components: {
            riseLoader
        }
    }
</script>

<style scoped>

</style>
